module.exports = __webpack_public_path__ + "static/media/beginning_of_lesson.6579529c.svg";